import React, { useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";

import ModalFrame from "./ModalFrame";

import { closeModal } from "store/state/ui/actions";
import IconSvgComponent from "components/common/IconSvgComponent";
import ButtonLink from "components/common/ButtonLink";
import Field from "components/common/Field";
import Form, {
  FormBody,
  FormActions,
  FormHead,
  FormLogo,
  FormTitle,
  FormRowGrid,
  FormCol,
  FormControls,
} from "styles/components/Form";
import { addNotification } from "store/state/ui/actions";
import { LEVELS, createNotification } from "utilities/notification";
import { restApiBaseUrl } from "constants/api";
import { getAccessToken } from "utilities/localStore";

const apiUrl = restApiBaseUrl;

const FormCreateAccount = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [formState, setFormState] = useState({
    name: "",
    type: "",
    discipline_id: "",
    assessment_series_id: "",
    version: "",
    form: "",
  });
  const [error, setError] = useState("");
  const [creatingAssessment, setCreatingAssessment] = useState(false);

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    setError("");
    setFormState((previous) => {
      return {
        ...previous,
        [name]: value,
      };
    });
  };

  const handleSelectChange = (name) => (selectedOption) => {
    setError("");
    setFormState((previous) => {
      return {
        ...previous,
        [name]: selectedOption.value,
      };
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    setCreatingAssessment(true);

    try {
      const body = formState;

      const result = await fetch(`${apiUrl}/rest/assessments`, {
        mode: "cors",
        method: "post",
        headers: {
          Authorization: getAccessToken(),
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      }).then((response) => response.json());

      if (result.status === "error") {
        throw Error(result.message);
      }

      history.push(`/admin/assessments/${result.data.id}`);
      dispatch(closeModal());
    } catch (error) {
      console.error(error);
      setError("Encountered an issue while creating assessment.");
    }

    setCreatingAssessment(false);
  };

  const isFormDisabled = useMemo(() => {
    if (["name", "type", "discipline_id", "form"].some((field) => !formState[field])) {
      return true;
    }

    if (creatingAssessment) {
      return true;
    }

    if (error) {
      return true;
    }

    return false;
  }, [formState, creatingAssessment, error]);

  return (
    <Form className="form" onSubmit={handleSubmit}>
      <FormHead>
        <FormLogo>
          <IconSvgComponent iconPath="svg/ico-assessment-lg.svg" />
        </FormLogo>
        <FormTitle>Create Assessment</FormTitle>
      </FormHead>

      {/* <FieldErrors
        formErrors={formErrors}
        apiErrorMessage={this.props.accountsApiErrors[operation].message}
        slider={this.props.edit && "slider"}
      /> */}

      <FormBody>
        <FormRowGrid>
          <FormCol>
            <FormControls>
              <Field
                type="text"
                id="name"
                name="name"
                placeholder="Name"
                value={formState.name}
                onChange={handleInputChange}
                required
                max="255"
              />
              <Field
                isSelect
                id="type"
                name="type"
                placeholder="Type"
                value={
                  formState.type
                    ? {
                        id: formState.type,
                        value: formState.type,
                        label: formState.type,
                      }
                    : null
                }
                onChange={handleSelectChange("type")}
                options={["Placement Assessment", "Exam", "Practice Assessment"].map((type) => {
                  return {
                    id: type,
                    value: type,
                    label: type,
                  };
                })}
                required
              />
              <Field
                isSelect
                id="discipline_id"
                name="discipline_id"
                placeholder="Discipline"
                value={
                  formState.discipline_id
                    ? {
                        id: formState.discipline_id,
                        value: formState.discipline_id,
                        label: ["Mathematics", "Physics", "Chemistry", "Science", "Biology"][
                          Number(formState.discipline_id) - 1
                        ],
                      }
                    : null
                }
                onChange={handleSelectChange("discipline_id")}
                options={["Mathematics", "Physics", "Chemistry", "Science", "Biology"].map(
                  (discpline, index) => {
                    return {
                      id: String(index + 1),
                      value: String(index + 1),
                      label: discpline,
                    };
                  }
                )}
                required
              />
              {/* <Field
                isSelect
                id="assessment_series_id"
                name="assessment_series_id"
                placeholder="Assessment Series"
                value={formState.assessment_series_id}
                onChange={handleSelectChange}
                // error={!formErrors.organization.valid}
              /> */}
              <Field
                type="text"
                id="form"
                name="form"
                placeholder="Form"
                value={formState.form}
                onChange={handleInputChange}
                required
              />
              <Field
                type="number"
                id="version"
                name="version"
                placeholder="Version"
                value={formState.version}
                onChange={handleInputChange}
              />
            </FormControls>
          </FormCol>
        </FormRowGrid>
      </FormBody>

      <FormActions>
        <ButtonLink type="submit" violet hasIcon disabled={isFormDisabled} isLoading={true}>
          <span>Create Assessment</span>
          <IconSvgComponent iconPath="svg/ico-check-white.svg" />
        </ButtonLink>
      </FormActions>
    </Form>
  );
};

const ModalCreateAssessment = (props) => {
  return (
    <ModalFrame>
      <FormCreateAccount />
    </ModalFrame>
  );
};

export default ModalCreateAssessment;
